// export var apiUrl = "http://localhost:8089/index.php";
// export  var apiUrl = "http://localhost/api.futcenter/index.php?";
export var apiUrl = "https://apifutbol.ramico.com.mx/index.php";
export var imgUrl = "https://apifutbol.ramico.com.mx/";
// export var apiUrl = "http://futcenterhmo.com/api/index.php";
// export var imgUrl = "http://futcenterhmo.com/api/uploads/";


// WEBPACK FOOTER //
// ./src/constants.js